module.exports = __webpack_public_path__ + "static/media/Tera.4bba77b4.png";